// ─── Centralized API Configuration ──────────────────────────────────
// All API calls should import BASE_URL from this file.
// The value comes from the .env file (REACT_APP_API_URL).
// To change the backend URL, edit .env — not individual files.
// ────────────────────────────────────────────────────────────────────

const BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

// Helper: returns the correct image URL.
// In production, images are stored on DigitalOcean Spaces and the URL
// is already a full https:// URL. In local dev, it's a relative path
// like /media/products/img.png that needs BASE_URL prepended.
export const getImageURL = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BASE_URL}${url}`;
};

export default BASE_URL;
